<template>
  <v-app>
    <v-content>
      <child/>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'Test'
}
</script>



// WEBPACK FOOTER //
// resources/js/layouts/test.vue